module.exports = __webpack_public_path__ + "assets/img/102003.c941ca6c.svg";